import { ValueOf } from "@recare/core/types";
import { useEffect } from "react";
import {
  isValidSession,
  useAllowBrowserNotifications,
} from "./NotificationPermission";

const BROWSER_ACTIONS = {
  NAVIGATE: "navigate",
};

export const BROWSER_NOTIFICATION = {
  REQUEST: 1,
  VALIDATE: 2,
  NEW_MESSAGE: 3,
  ATTRIBUTION_CANCELLATION: 4,
  NOT_AVAILABLE: 5,
  REQUEST_AVAILABLE: 6,
  PROFILE_EDITED: 7,
  NEW_MESSAGE_FROM_PROVIDER: 8,
  TEST: -1,
};

type NavigationPayload = {
  auction_id?: number;
  careprovider_id?: number;
  patient_id?: number;
  request_id?: number;
  type?: ValueOf<typeof BROWSER_NOTIFICATION>;
};

type NavigationData = {
  action: "navigate";
  payload: NavigationPayload | undefined;
};

const getUrlFromNavigationPayload = (navigationPayload: NavigationPayload) => {
  const { auction_id, careprovider_id, patient_id, request_id, type } =
    navigationPayload;

  const providerUrl = `${self.location.origin}/careprovider/dashboard`;

  if (type === BROWSER_NOTIFICATION.TEST) {
    return providerUrl;
  }

  const isNotificationForClinic =
    type === BROWSER_NOTIFICATION.NEW_MESSAGE_FROM_PROVIDER;

  if (isNotificationForClinic) {
    const clinicUrl = `${self.location.origin}/app/clinic/dashboard`;

    if (patient_id && auction_id && request_id) {
      return `${clinicUrl}/patient/${patient_id}/auction/${auction_id}/request/${request_id}`;
    }

    return clinicUrl;
  }

  if (careprovider_id && request_id) {
    return `${providerUrl}/${careprovider_id}/requests/${request_id}`;
  }

  return providerUrl;
};

export const useHandlePushMessageNavigation = () => {
  const allow = useAllowBrowserNotifications();

  useEffect(() => {
    if (!allow) return;
    const err = isValidSession();
    if (err) {
      console.error(`invalid session for push navigation: ${err}`);
      return;
    }

    const handleNavMessage = (e: PushEvent) => {
      const navigationData = e.data as unknown as NavigationData | undefined;

      if (!navigationData?.payload) return;

      if (navigationData.action === BROWSER_ACTIONS.NAVIGATE) {
        window.location.href = getUrlFromNavigationPayload(
          navigationData.payload,
        );
      }
    };

    navigator.serviceWorker.addEventListener(
      "message",
      handleNavMessage as (e: Event) => void,
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        "message",
        handleNavMessage as (e: Event) => void,
      );
    };
  }, []);
};
